import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { INgxSelectOption } from 'ngx-select-ex';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InvestigationData } from '../../../../@core/interfaces/masters/investigations';
import { environment } from '../../../../../environments/environment';
import { RolesData } from '../../../../@core/interfaces/common/roles';

@Component({
  selector: 'ngx-review-test',
  templateUrl: './review-test.component.html',
  styleUrls: ['./review-test.component.scss']
})
export class ReviewTestComponent implements OnInit {
  valuefield:string=''
  @Output() dataEvent: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Input() reviewTestList:Array<any>=[];
  @Output() investigationEvent: EventEmitter<any[]> = new EventEmitter<any[]>();
  isAddmsg: boolean = false;
  isEditmsg: boolean = false;
  errormsg: boolean = false;
  phlen:number=4000;
  phcharflag:boolean=false;
  baseurl = environment.apiUrl + "/PatientCareTaskMaster";
  @Input() InvestigationList:Array<any> = [];
  reviewTestForm:FormGroup;
  isSubmitted:boolean=false;
  @Input() visitDoctorId: any;
  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  private userId = localStorage.getItem("userId");
  placeholder: string = "Select";
  @Input() regId: string;
  @Input() visitId: number;
  isAddComponent: boolean = true;
  dupName: boolean = false;
  editData: any = {};
  get fval(): { [key: string]: AbstractControl } { return this.reviewTestForm.controls; }
  protected readonly unsubscribe$ = new Subject<void>();
  constructor(private rolesData: RolesData,protected patientinvestigationSrvc: InvestigationData,private fb: FormBuilder) {
    this.reviewTestForm = this.fb.group({
      serviceId: this.fb.control('',[Validators.required]),
      notes: this.fb.control('')
    })

  }

  ngOnInit(): void {
    this.loadPatientInvestigations();
  }

  checkDup(event) {
    var found = this.reviewTestList?.filter(x => x?.serviceId == event?.id);
    if (found?.length > 0 && !this.isAddComponent) {
      if (found[0]?.qB_Header_Name == this.editData?.qB_Header_Name) {
        this.dupName = false;
      }
      else {
        this.dupName = true;
      }
    }
    else
      if (found.length > 0) {
        this.dupName = true;
      }
      else {
        this.dupName = false;
      }
  }


  editReviewTest( data) {
    this.editData = data;
    this.serviceMstId=data?.serviceId;
    this.loadPatientInvestigations();
    this.reviewTestForm.get('serviceId').setValue(data?.serviceId);
    this.reviewTestForm.get('notes').setValue(data?.notes);
    this.isAddComponent = false;
    this.serviceMstId=null;
  }

  NotesTypevalueChanges(value) {
    if (value != null && value != ''){
      this.phcharflag = true;
      this.phlen = 4000 - value.length;
    }
  }

  loadPatientInvestigations(): void {
    if(!this.visitDoctorId || !this.visitId){
      return;
    }
    this.patientinvestigationSrvc.list(`investigation/${this.tenantId}/${this.branchId}/${this.regId}/${this.visitId}/GetPaitentInvestigationDatasWithMaster/${this.visitDoctorId}?tenantId=${this.tenantId}&isLoadMaster=true&isLoadPatientData=false&skip=${this.skip}&take=${this.take}&name=${this.name}&serviceMstId=${this.serviceMstId}` )
    .pipe(takeUntil(this.unsubscribe$)).subscribe((datum: any) => {
      const newList = datum.masterData
        .map(x => ({
          ...x,
          concatName: x?.serviceType
            ? `${x?.name} - ${x?.serviceType}`
            : `${x?.name} - ${x?.serviceCategory?.name}`
        }))
        .filter(ele => ele.isActive === 'Y');

      if (this.skip === 0) {
        this.InvestigationList = newList;
      } else {
        this.InvestigationList = [...this.InvestigationList, ...newList];
      }

      this.investigationEvent.emit(this.InvestigationList);
    }
  )

  }

    onSave(event) {
      event.target.disabled = true;
  
      this.isSubmitted = true;
  
      if (this.reviewTestForm.valid  && !this.dupName) {
  
        const updatedFormValue = {
          "serviceId": this.reviewTestForm.value.serviceId,
          "servicename": this.InvestigationList.find(x => x.id == this.reviewTestForm.value.serviceId)?.concatName,
          "notes": this.reviewTestForm.value.notes
        };
  
        let postData = {
          "pcId": this.isAddComponent ? null : this.editData?.pcId,
          "woId": null,
          "regId": this.regId,
          "ipId": null,
          "careTaskType": 37,
          "careTaskPlace": null,
          "careTaskStatus":  4,
          "CreatedDate":this.isAddComponent ? new Date() : this.editData?.createdDate,
          "CreatedBy": this.isAddComponent ? parseInt(this.userId) : this.editData?.createdBy,
          "UpdatedDate": this.isAddComponent ? null : new Date(),
          "UpdatedBy": this.isAddComponent ? null : parseInt(this.userId),
          "TenantId": this.tenantId,
          "BranchId": this.branchId,
          "CreatedIP": null,
          "UpdatedIP": null,
          "inputJson": JSON.stringify(updatedFormValue),
          "visitId": this.visitId,
          "SubstatusName": 'Review_Test'
        }

        if (this.isAddComponent) { 
          this.rolesData.create(this.baseurl + "/PostPatientCareTaskMst", postData).subscribe(
            (response) => {
              this.dataEvent.emit( response.details );
              this.reset();
            },
            (err) => {
              event.target.disabled = false;
              this.errormsg = true;
              setTimeout(() => {
                this.errormsg = false;
              }, 4000)
            },
            () => {
              event.target.disabled = false;
              this.isAddmsg = true;
              setTimeout(() => {
                this.isAddmsg = false;
              }, 4000)
            }
          );
        }
        else {
          this.rolesData.update(this.baseurl + "/UpdatePatientCareTaskMst/" + this.editData?.pcId, postData).subscribe(
            (response) => {
              this.dataEvent.emit( response.details );
              this.reset();
              this.isAddComponent = true;
            },
            (err) => {
              event.target.disabled = false;
              this.errormsg = true;
              setTimeout(() => {
                this.errormsg = false;
              }, 4000)
            },
            () => {
              event.target.disabled = false;
              this.isEditmsg = true;
              setTimeout(() => {
                this.isEditmsg = false;
              }, 4000)
            }
  
          );
  
  
        }
      }
      else{
        event.target.disabled = false;
        this.errormsg = true;
              setTimeout(() => {
                this.errormsg = false;
              }, 4000)
      }
    }


    reset() {
      this.reviewTestForm.reset();
      this.isSubmitted = false;
      this.phlen=4000;
      this.phcharflag=false;
      this.dupName=false;
    }
    skip:number = 0;
    take:number = 50;
    name:string="";
    serviceMstId:string=null;
    onSearch(event: any) {

      this.name =  event?.target?.value || '';
      this.skip = 0;
      this.InvestigationList = [];
    
      this.loadPatientInvestigations();
    }
    loadMore() {
    
      this.skip += this.take;
      this.loadPatientInvestigations();
    
    }
}
